module.exports = __webpack_public_path__ + "img/blog1.1cda31e8.png";